<div class="mt-20">
  <establishment-main-info-banner (isclose)="onEstablishmentStatusChange($event)"></establishment-main-info-banner>

  <div class="mt-6 mb-3">
    <div class="mx-16 3xl:mx-auto px-4 mb-10">
      <shared-arrow-back></shared-arrow-back>
    </div>

    <establishment-main-bar-search-products [isOpen]="isClosed"></establishment-main-bar-search-products>
    <div class="mt-10 mb-2 mx-16 3xl:mx-auto">
      <establishment-main-list-categories
      (filterChanged)="onFilterChanged($event)"
    ></establishment-main-list-categories>
    </div>
  </div>
  <div class="mx-auto" style="height: auto; overflow-y: auto;">
    <establishment-main-list-products [isOpen]="isClosed"
      [filterEvent]="currentFilter"
      #listProducts
    ></establishment-main-list-products>
  </div>

  <div class="">
    <comments-establishment [establishmentId]="establishmentId"></comments-establishment>
  </div>
</div>
